import React, { useEffect, useState, useRef } from "react";
import useHttp from '../../../../hook/use-http';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import Chart from 'react-apexcharts'
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";

export default function BMSVehicleScatter_Jupiter({ apiend, gloablfilter, type, chartBMSDropdown }) {

  console.log("chartBMSDropdown",chartBMSDropdown);
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [width, setWidth] = useState(window.innerWidth);

  const [barColorMax, setBarColorMax] = useState("#89CCD8")
  const [barColorMin, setBarColorMin] = useState("#348393")

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width < 768
  const issmMobile = width < 385;

  const appyData = (data) => {
    const res_result = data;

    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        name: chartBMSDropdown,
        data: []
      }]
      temp_result.sort((a, b) => b.fields.gun_start[0].localeCompare(a.fields.gun_start[0]));

      temp_result.map((x, i) => {
        res_result_final[0].data.push([parseInt(i + 1), x.fields[chartBMSDropdown][0].toFixed(3)]);
      })

      setChartData((prestate) => res_result_final);
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      window.dispatchEvent(new Event('resize'));
    }
  }
  let xvalue, yvalue;
  if (isMobile === true) {
    xvalue = 85; yvalue = 80
  }
  else {
    xvalue = 85; yvalue = 78
  }

  const options = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColorMin],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: chartBMSDropdown,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: "Cycle Number",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: yvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };
  const options1 = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',
    },
    colors: [barColorMin],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: chartBMSDropdown,
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 7,
      title: {
        text: "Cycle Number",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: xvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  useEffect(() => {
    if (type === 'Fast') {
      setBarColorMin("#FFD1A4")
      setBarColorMax("#F39C48")
    } else {
      setBarColorMin("#348393")
      setBarColorMax("#89CCD8")
    }
    fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }, [gloablfilter, type, chartBMSDropdown])

  const rezoom = () => {
    window.$('#torquespeedsecondBMS_V').modal('show');
    window.dispatchEvent(new Event('resize'));
  }

  return (
    <>
      <div className="modal fade" id="torquespeedsecondBMS_V" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">BMS cell voltage - {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart options={options1} series={chartdata} type="scatter" width="100%" height="360px" />)}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} onClick={rezoom} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart type="scatter" width="100%" height="auto" series={chartdata} options={options} />)}
    </>
  );
}
